import React, { useEffect, useState } from "react";
export default function useAccessibleFocus(items) {
    const [focused, setFocused] = useState(-1);
    const refs = items.map(() => React.createRef());
    function up() {
        setFocused((prev) => prev - 1 >= 0 ? prev - 1 : refs.length - 1);
    }
    function down() {
        setFocused((prev) => prev + 1 < refs.length ? prev + 1 : 0);
    }
    function handleKeyDown(event) {
        event.preventDefault();
        if (event.key === "Tab") {
            down();
        }
        if (event.key === "ArrowDown") {
            down();
        }
        if (event.key === "ArrowUp") {
            up();
        }
    }
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    useEffect(() => {
        var _a;
        if (focused >= 0 && focused < refs.length) {
            (_a = refs[focused].current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [focused]);
    return refs;
}
